import { PAYMENT_HUB_RENEWAL_TYPE } from '@src/constants/subscription';

const { PACKAGE_TYPE } = require('@src/constants/package');
const { PAYMENT_METHOD_TYPE } = require('@src/constants/payment');

export const checkInAppPurchase = (packageType, paymentMethodType) =>
  packageType === PACKAGE_TYPE.STUDIO &&
  paymentMethodType &&
  [PAYMENT_METHOD_TYPE.GOOGLE, PAYMENT_METHOD_TYPE.APPLE].includes(
    paymentMethodType,
  );

export const checkAutoRenewOrder = (renewalType) =>
  renewalType === PAYMENT_HUB_RENEWAL_TYPE.AUTO_RENEW;
